import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted } from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import {Chart} from 'highcharts-vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTGRAPHS from '@/constants/graphs';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getTimeZone } from '@/functions/project';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnChart',
  props: {
    color       : { required:true },
    title       : { required:true },
    arrayIPs    : { required:true },
    thridArray  : { required:true },
    firstArray  : { required:true },
    secondArray : { required:true },
    fourthArray : { required:true },
    name        : { type:String, required:true },
},
  setup(__props) {

const props = __props;


const yAxisTitle    = ref(CONSTGRAPHS.YAXISLABEL[props.name] || '');

/* eslint-disable */
const chartOptions:any = ref({
    chart: {
        type: 'column',
        options3d: {
            enabled: true,
            alpha: 15,
            beta: 15,
            viewDistance: 25,
            depth: 40
        }
    },
    title: {
        text: props.title
    },
    credits: {
        enabled: false
        },
    yAxis: {
        title: { text: yAxisTitle  }
    },
    xAxis: {
        categories: props.arrayIPs,
        title: { text: null },
        gridLineWidth: 1,
        lineWidth: 0
    },
    series: [
        {
            name: 'Normal',
            data: props.firstArray,
        },
        {
            name: 'Alerta',
            data: props.thridArray,
        },
        {
            name: 'Alarma',
            data: props.secondArray,
        },
        {
            name: 'Down',
            data: props.fourthArray,
        },
    ],
    plotOptions: {
        column: {
            stacking: 'normal',
            depth: 40
        }
    },
    exporting: { enabled: false },
    time: {
        timezone: getTimeZone()
    }
})


const chartRef = ref<any>();
const duplicateChart = ref();

onMounted(async () => {
    setTimeout(() => {
        duplicateChart.value = chartRef.value;
    }, 500);
});

onUnmounted(() => {
    if(duplicateChart.value){
        duplicateChart.value.chart.destroy();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Chart), {
      constructorType: 'chart',
      class: "hc",
      options: chartOptions.value,
      ref_key: "chartRef",
      ref: chartRef
    }, null, 8, ["options"])
  ]))
}
}

})